import React, { useCallback, useEffect, useRef, useState } from "react";
import GoogleMapReactLib from "google-map-react";
import { $googleApiKey } from "constant";
import { Marker } from "./components/Marker";
import { CoordAddress, GoogleMapAutoComplete } from "./GoogleMapAutoComplete";

const GoogleMapReact =
  GoogleMapReactLib as unknown as React.ComponentType<GoogleMapReactLib.Props>;

interface IGoogleMaps {
  center?: GoogleMapReactLib.Coords;
  zoom?: number;
  coords?: GoogleMapReactLib.Coords[];
  onPlaceSelected?: (coordAddress: CoordAddress) => void;
}

export const GoogleMaps = ({
  center = {
    lat: Number(import.meta.env.VITE_CENTER_LAT || 11.020954221307532),
    lng: Number(import.meta.env.VITE_CENTER_LNG || 106.31920848465806),
  },
  coords = [],
  zoom = 11,
  onPlaceSelected,
}: IGoogleMaps) => {
  const [coordSelected, setCoordSelected] = useState<CoordAddress | null>();
  const [apiReady, setApiReady] = useState(false);
  const mapRef = useRef<any>(null);

  const defaultBounds = {
    north: center.lat + 0.1,
    south: center.lat - 0.1,
    east: center.lng + 0.1,
    west: center.lng - 0.1,
  };

  const handlePlaceSelect = useCallback(
    (coordAddress: CoordAddress) => {
      setCoordSelected(coordAddress);
      onPlaceSelected?.(coordAddress);
    },
    [onPlaceSelected],
  );

  useEffect(() => {
    if (coordSelected && mapRef.current) {
      mapRef.current.panTo({
        lat: coordSelected.lat,
        lng: coordSelected.lng,
      });
      mapRef.current.setZoom(15);
    }
  }, [coordSelected]);

  return (
    <div style={{ width: "100%" }}>
      {apiReady && (
        <GoogleMapAutoComplete
          defaultBounds={defaultBounds}
          onPlaceSelected={handlePlaceSelect}
        />
      )}

      <div
        style={{
          height: "400px",
          width: "100%",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <GoogleMapReact
          bootstrapURLKeys={{
            key: $googleApiKey || "",
            libraries: ["places"],
            language: "vi",
          }}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map }) => {
            mapRef.current = map;
            setApiReady(true);
          }}
          defaultCenter={center}
          defaultZoom={zoom}
          options={{
            gestureHandling: "greedy",
          }}
        >
          {coordSelected && (
            <Marker lat={coordSelected.lat} lng={coordSelected.lng} />
          )}
          {coords.map((e, i) => (
            <Marker key={i} lat={e.lat} lng={e.lng} />
          ))}
        </GoogleMapReact>
      </div>
    </div>
  );
};
